import styled from '@emotion/styled';
import { BadRequest } from '@tsed/exceptions';
import type { GetStaticProps, InferGetStaticPropsType } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { CardContainer } from '@/components/common/CardContainer';
import { disclaimerConfig } from '../../lib/i18n/configs';

type Props = {
  /** Add Route props here */
};

const ActionCtn = styled.div({
  flex: '0 0 auto',
  // //padding: '12px 40px',
  display: 'flex',
  ['> *']: {
    flex: '1 1 auto',
    display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',
  },
});

export default function DisclaimerIndex(
  _props: InferGetStaticPropsType<typeof getStaticProps>
) {
  const { t } = useTranslation();

  return (
    <>
      <CardContainer>
        <div css={{ textAlign: 'center' }}>
          <h3>{t('disclaimer:Disclaimer')}</h3>
        </div>
        <ActionCtn>{t('disclaimer:Para1')}</ActionCtn>
        <br />
        <ActionCtn>
          <h5>{t('disclaimer:Title2')}</h5>
        </ActionCtn>
        <ActionCtn>{t('disclaimer:Para2')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para3')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para4')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para5')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para6')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para7')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para8')}</ActionCtn>
        <br />
        <ActionCtn>
          <h5>{t('disclaimer:Title9')}</h5>
        </ActionCtn>

        <ActionCtn>{t('disclaimer:Para9')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para10')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para11')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para12')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para13')}</ActionCtn>
        <br />
        <ActionCtn>{t('disclaimer:Para14')}</ActionCtn>
        <br />
      </CardContainer>
    </>
  );
}

export const getStaticProps: GetStaticProps<Props> = async (context) => {
  const { locale } = context;
  if (locale === undefined) {
    throw new BadRequest('locale is missing');
  }
  const { i18nNamespaces } = disclaimerConfig;
  return {
    props: {
      ...(await serverSideTranslations(locale, i18nNamespaces.slice())),
    },
  };
};
